import { CanMakePaymentResult } from '@stripe/stripe-js';
import { Text } from '@youversion/design-system-components';
import { ApplePay, GooglePay, Link } from 'components/images';
import React, { useMemo } from 'react';
import { useAvailableWallets } from 'utils/store/availableWallets';

import PaymentMethodBox from './PaymentMethodBox';

export interface Props {
  editing: boolean;
  onClick: () => void;
  selected: boolean;
}

export default function PaymentRequest({ selected, onClick, editing }: Props) {
  const { availableWallets } = useAvailableWallets();
  const paymentInfo = useMemo(() => paymentRequestLabel(availableWallets), [availableWallets]);

  if (!paymentInfo) {
    return null;
  }

  return (
    <PaymentMethodBox
      editing={editing}
      onClick={onClick}
      selected={selected}
      testId='add-payment-request'
      value='payment-request'
    >
      <div className='flex items-center'>
        {paymentInfo.logo}

        <Text className='mis-2' size='lg' variant='buttonLabel'>
          {paymentInfo.text}
        </Text>
      </div>
    </PaymentMethodBox>
  );
}

interface PaymentInfo {
  logo: React.ReactNode;
  text: string;
}
function paymentRequestLabel({ applePay, googlePay, link }: CanMakePaymentResult): PaymentInfo | undefined {
  if (applePay) {
    return {
      logo: <ApplePay />,
      text: 'Apple Pay',
    };
  } else if (googlePay) {
    return {
      logo: <GooglePay />,
      text: 'Google Pay',
    };
  } else if (link) {
    return {
      logo: <Link />,
      text: 'Link',
    };
  }
}
